module.exports = __webpack_public_path__ + "assets/7f7cd6b1bc986cf5979233269ed2e598.gif";